/*
 * tour-options.js — Tour booking form with shared / private tiered options.
 * Loaded only on pages using the tour_options pricing mode (Palmetto Bay Trip).
 * Namespaced; does not touch any other tour page.
 */
(function () {
  'use strict';

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function isWedOrSat(dateStr) {
    if (!dateStr) return false;
    var d = new Date(dateStr + 'T12:00:00').getDay();
    return d === 3 || d === 6;
  }

  function initForm(config) {
    var form = document.getElementById(config.formId);
    if (!form || form.dataset.tourReady) return;
    form.dataset.tourReady = '1';
    form.addEventListener('submit', function (e) { e.preventDefault(); });

    var optSel      = form.querySelector('[data-tour-option]');
    var guestsField = form.querySelector('[data-tour-guests-field]');
    var guestsInput = form.querySelector('[data-tour-guests]');
    var guestsHint  = form.querySelector('[data-tour-guests-hint]');
    var dateInput   = form.querySelector('[data-tour-date]');
    var dateHint    = form.querySelector('[data-tour-date-hint]');
    var dateError   = form.querySelector('[data-tour-date-error]');
    var totalEl     = form.querySelector('[data-tour-total]');
    var totalHint   = form.querySelector('[data-tour-total-hint]');
    var errorEl     = form.querySelector('[data-tour-error]');
    var submitBtn   = form.querySelector('[data-tour-submit]');
    var section     = form.closest('[data-section-id]');
    var sidebarPrice = section ? section.querySelector('[data-booking-live-price]') : null;

    var transportSel = form.querySelector('[data-tour-transport]');
    var pickupField  = form.querySelector('[data-tour-pickup-field]');
    var pickupInput  = form.querySelector('[data-tour-pickup]');
    var zoneField    = form.querySelector('[data-tour-zone-field]');
    var zoneSel      = form.querySelector('[data-tour-zone]');
    var zoneNote     = form.querySelector('[data-tour-zone-note]');

    if (!optSel || !submitBtn) return;

    function opt()        { return optSel.options[optSel.selectedIndex]; }
    function mode()       { return opt().getAttribute('data-mode'); }
    function cents()      { return parseInt(opt().getAttribute('data-cents'), 10) || 0; }
    function optPeople()  { return parseInt(opt().getAttribute('data-people'), 10) || 1; }
    function wedSatOnly() { return opt().getAttribute('data-wedsat') === '1'; }

    function guests() {
      if (mode() === 'flat') return optPeople();
      return parseInt(guestsInput && guestsInput.value, 10) || 0;
    }

    function recalc() {
      var total = (mode() === 'flat') ? cents() : guests() * cents();
      if (totalEl) totalEl.textContent = formatMoney(total);
      if (sidebarPrice) sidebarPrice.textContent = formatMoney(total);
      if (totalHint) {
        if (mode() === 'pp' && guests() > 0) {
          totalHint.textContent = guests() + ' guest' + (guests() === 1 ? '' : 's') + ' × ' + formatMoney(cents());
          totalHint.hidden = false;
        } else {
          totalHint.hidden = true;
        }
      }
    }

    function validateDate() {
      if (!dateInput) return true;
      if (wedSatOnly() && dateInput.value && !isWedOrSat(dateInput.value)) {
        if (dateError) dateError.hidden = false;
        dateInput.setCustomValidity('Shared tours run on Wednesdays and Saturdays only.');
        return false;
      }
      if (dateError) dateError.hidden = true;
      dateInput.setCustomValidity('');
      return true;
    }

    function syncOption() {
      var pp = mode() === 'pp';
      var minP = optPeople();
      if (guestsField) guestsField.hidden = !pp;
      if (guestsInput) {
        guestsInput.disabled = !pp;
        guestsInput.min = minP;
        if ((parseInt(guestsInput.value, 10) || 0) < minP) guestsInput.value = minP;
      }
      if (guestsHint) {
        guestsHint.textContent = (minP >= 4) ? 'Minimum 4 guests for this option.' : 'Price is per person.';
      }
      if (dateHint) {
        dateHint.textContent = wedSatOnly()
          ? 'Shared tours run on Wednesdays and Saturdays.'
          : 'Private tours can be booked any day.';
      }
      validateDate();
      recalc();
    }

    function syncZone() {
      if (!zoneSel || !zoneNote) return;
      zoneNote.hidden = zoneSel.value.indexOf('Outside') !== 0;
    }

    function syncTransport() {
      if (!transportSel) return;
      var needs = transportSel.value === 'Yes';
      if (pickupField) pickupField.hidden = !needs;
      if (pickupInput) {
        pickupInput.disabled = !needs;
        if (needs) {
          pickupInput.setAttribute('required', 'required');
        } else {
          pickupInput.removeAttribute('required');
          pickupInput.value = '';
        }
      }
      if (zoneField) zoneField.hidden = !needs;
      if (zoneSel) {
        zoneSel.disabled = !needs;
        if (!needs) zoneSel.selectedIndex = 0;
      }
      syncZone();
    }

    optSel.addEventListener('change', syncOption);
    if (guestsInput) guestsInput.addEventListener('input', recalc);
    if (dateInput) dateInput.addEventListener('change', validateDate);
    if (transportSel) transportSel.addEventListener('change', syncTransport);
    if (zoneSel) zoneSel.addEventListener('change', syncZone);

    syncOption();
    syncTransport();

    submitBtn.addEventListener('click', function () {
      if (errorEl) errorEl.hidden = true;
      validateDate();
      if (!form.reportValidity()) return;

      var qty = (mode() === 'flat') ? 1 : guests();
      if (mode() === 'pp' && qty < optPeople()) {
        if (errorEl) {
          errorEl.textContent = 'Please enter at least ' + optPeople() + ' guests for this option.';
          errorEl.hidden = false;
        }
        return;
      }

      function val(key) {
        var el = form.querySelector('[data-tour-' + key + ']');
        return el ? el.value.trim() : '';
      }

      var props = {
        'Tour option': opt().textContent.trim(),
        'Number of guests': String(guests()),
        'Tour date': val('date'),
        'Tour time': val('time'),
        'Full name': val('name'),
        'WhatsApp': val('whatsapp')
      };
      if (transportSel) props['Needs transport'] = transportSel.value;
      if (pickupInput && !pickupInput.disabled && pickupInput.value.trim()) {
        props['Pickup location'] = pickupInput.value.trim();
      }
      if (zoneSel && !zoneSel.disabled) props['Pickup zone'] = zoneSel.value;
      var comments = val('comments');
      if (comments) props['Comments'] = comments;

      submitBtn.disabled = true;
      var originalHtml = submitBtn.innerHTML;
      submitBtn.textContent = 'Processing…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(optSel.value, 10), quantity: qty, properties: props }] })
      }).then(function (r) {
        if (!r.ok) throw new Error('cart');
        window.location.href = '/cart';
      }).catch(function () {
        submitBtn.disabled = false;
        submitBtn.innerHTML = originalHtml;
        if (errorEl) {
          errorEl.textContent = 'Sorry, something went wrong. Please try again or book via WhatsApp.';
          errorEl.hidden = false;
        }
      });
    });
  }

  function init() {
    var nodes = document.querySelectorAll('[data-tour-config]');
    Array.prototype.forEach.call(nodes, function (n) {
      try { initForm(JSON.parse(n.textContent)); } catch (e) { /* noop */ }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
